import {
  Button,
  ButtonGroup,
  ConfirmationModal,
  ModalBody,
  Paragraph,
} from "@george-labs.com/design-system"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { setBeError } from "../../app/slices/beErrorSlice"
import { store } from "../../app/store"

const BeErrorComponent = () => {
  const { t } = useTranslation()
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    setIsOpen(true)
  }, [])

  return (
    <ConfirmationModal
      onClose={() => store.dispatch(setBeError(false))}
      animate={true}
      isOpen={isOpen}
      closeLabel={t("common.close")}
      confirmationType={ConfirmationModal.CONFIRMATION_TYPE.ERROR}
      title={t("common.errors.backend.title")}
      footer={
        <ButtonGroup>
          <Button
            onClick={() => store.dispatch(setBeError(false))}
            disabled={false}
          >
            {t("common.button.ok")}
          </Button>
        </ButtonGroup>
      }
    >
      <ModalBody>
        <Paragraph>{t("common.errors.backend.message")}</Paragraph>
      </ModalBody>
    </ConfirmationModal>
  )
}

export default BeErrorComponent
